module.exports = __webpack_public_path__ + "img/tool_advanced.4f13fd5d.png";